module.exports = __webpack_public_path__ + "static/media/empty-shelves.b5e067b8.png";